import React, { FC } from 'react';
import styles from './InformationalAlert.module.css';
import { getUrlParam, isUnified, renderAsMarkdown } from '../helpers';
import { postAnchorClickEventToParentApp } from '../messageassist';
import { sendExternalLinkSelected } from '../analytics';

type InformationalAlertProps = {
    content?: string | React.ReactNode | null;
};

/**
 * Displays a global informational banner.
 *
 * String content is rendered as HTML
 */

export const InformationalAlert: FC<InformationalAlertProps> = ({
    content,
}) => {
    if (!content) {
        return null;
    }

    const containsHtmlTag =
        typeof content === 'string' && /<[^>]+>/.test(content);
    const stringContentHtml =
        typeof content === 'string'
            ? containsHtmlTag
                ? content
                : renderAsMarkdown(content)
            : '';

    const handleOnClick = async (e: React.MouseEvent<HTMLElement>) => {
        const anchorElement = e.target as HTMLAnchorElement;

        if (
            !anchorElement ||
            !anchorElement.href ||
            !anchorElement.text ||
            anchorElement.text === ''
        ) {
            return;
        }

        if (isUnified() && getUrlParam('hostappchannel')) {
            // For app-based MA
            await postAnchorClickEventToParentApp(
                e,
                anchorElement.href,
                anchorElement.text
            );
        } else {
            // For web-based MA and non-MA
            // For app-based non-MA
            sendExternalLinkSelected(anchorElement.text, anchorElement.href);
        }
    };

    return (
        <div className={styles.informationalAlertHeader}>
            {typeof content === 'string' ? (
                <div
                    onClick={handleOnClick}
                    className={styles.informationalAlertHeaderMessage}
                    dangerouslySetInnerHTML={{
                        __html: stringContentHtml,
                    }}
                />
            ) : (
                <div className={styles.informationalAlertHeaderMessage}>
                    {content}
                </div>
            )}
        </div>
    );
};
